import { CourseRelevantExecution } from '../models/course-relevant-execution.model';

export class AddCourseRelevantExecutions {
    static readonly type = '[CourseRelevantExecution] AddCourseRelevantExecutions';

    constructor(public payload: CourseRelevantExecution[]) {}
}
